import React from "react";
import ProfileListingPageLayout from "../components/ProfileListingPageLayout";
import Carousel from "../components/Carousel";
import carouselImages from "../data/carouselImages";

const Tonex: React.FC = () => {
  const description = (
    <p className="opacity-70 mt-4 lg:text-xl">
      Unlock the Legendary Tones of Mesa Boogie and Diezel with Premium TONEX
      Tone Models. Explore our extensive collection of meticulously crafted
      TONEX captures, designed to bring the iconic sounds of these high-gain
      amplifiers directly to your digital rig. Whether you're chasing the
      crushing rhythm of a Mesa Boogie Mark II or the articulate leads of a
      Einstein, our TONEX profiles deliver authentic and inspiring tones for
      your IK Multimedia TONEX pedal or software.
    </p>
  );

  return (
    <>
      <Carousel images={carouselImages} className=" max-h-1/6" />
      <ProfileListingPageLayout
        pageTitle="Tonex Tone Models"
        pageDescription={description}
        profileTypeFilter="tonex"
        titleGradientClass="gradient-text-tonex"
      />
    </>
  );
};

export default Tonex;
